import { Input, Textarea } from "@heroui/react";

const GeneralInfoStep = ({ register, errors }) => {
    return (
        <div className="flex flex-col gap-4">
            <Input
                {...register("name", {
                    required: "Nama pelanggan wajib diisi",
                })}
                label="Nama Pelanggan"
                placeholder="Contoh: PT. Maju Jaya"
                variant="bordered"
                isInvalid={!!errors.name}
                errorMessage={errors.name?.message}
                isRequired
            />

            <Textarea
                {...register("description")}
                label="Deskripsi"
                placeholder="Deskripsi singkat tentang pelanggan (opsional)"
                variant="bordered"
                minRows={3}
            />
        </div>
    );
};

export default GeneralInfoStep;
